
type TagColor = "orange" | "blue" | "pink" | "yellow" | "green";
type ProjectCategory = "web" | "app" | "ai";

type ProjectTag = {
  name: string;
  color: TagColor;
};

type Project = {
  name: string;
  category: ProjectCategory;
  description: string;
  tags: ProjectTag[];
  image: string;
  source_code_link?: string;
  urls?: string;
};


export const projects:Project[] = [
  {
    name: "Portfolio webiste",
    urls: "https://www.basnetraju.com.np/",
    category: "web",
    description:
      "Developed a portfolio website for Raju Basnet using Next.js, Tailwind CSS, and Framer Motion, featuring smooth animations and a responsive design to effectively showcase his video editing skills and projects.",
    tags: [
      {
        name: "Next.js",
        color: "blue",
      },
      {
        name: "Framer Motion",
        color: "green",
      },
      {
        name: "tailwind",
        color: "pink",
      },
    ],
    // image: 'raju.png',
    image:
      "https://res.cloudinary.com/doe77lyoi/image/upload/w_400,h_300,c_fill/v1725259885/f31tr8coyp6ra2zdlsri.png",
    source_code_link: "https://github.com/Nimeshregmi",
  },
  {
    name: "Nikunja Portfolio",
    urls: "https://nikunjaregmi.com.np/",
    category: "web",
    description:
      "Developed a portfolio website for a video editor using Next.js 15, Tailwind CSS, and Framer Motion, featuring smooth animations and a responsive design to effectively showcase video editing skills and projects.",
    tags: [
      {
        name: "Tailwind",
        color: "yellow",
      },
      {
        name: "Next.js",
        color: "green",
      },
      {
        name: "Framer Motion",
        color: "orange",
      },
    ],
    image: "/projects/nikunjaregmi.png",
    source_code_link: "https://github.com/Nimeshregmi",
  },
  {
    name: "EntranceDose App",
    urls: "https://play.google.com/store/apps/details?id=com.entrancedose.entrancedoseapp&hl=en&gl=US",
    category: "app",
    description:
      "Developed an educational app for NEB, CEE, and MBBS prep using modern tech, offering affordable courses by top teachers and helping thousands of students succeed in medical entrance exams.",
    tags: [
      {
        name: "Flutter",
        color: "orange",
      },
      {
        name: "Laravel",
        color: "pink",
      },
      {
        name: "Bloc",
        color: "green",
      },
    ],
    image: "/projects/entrancedoseapp.png",
    source_code_link: "https://github.com/Nimeshregmi",
  },
  {
    name: "House Price Prediction",
    category: "ai",
    description:
      "ML-powered house price predictor using Pandas, Numpy & Scikit-learn. Features a sleek HTML/CSS/JS frontend with a Flask backend.",
    tags: [
      {
        name: "Keras",
        color: "green",
      },
      {
        name: "Flask",
        color: "pink",
      },
      {
        name: "Pandas",
        color: "green",
      },
      {
        name: "Numpy",
        color: "pink",
      },
    ],
    image: "/projects/house_price.jpeg",
    source_code_link: "https://github.com/Nimeshregmi/HousePricePrediction",
  },
  {
    name: "Agency webiste",
    category: "web",
    urls: "https://www.bipincreates.com/",
    description:
      "Developed the BipinCreates website using Next.js, Tailwind CSS, and Framer Motion to deliver a responsive and dynamic user experience.",
    tags: [
      {
        name: "Tailwind",
        color: "blue",
      },
      {
        name: "Next.js",
        color: "green",
      },
      {
        name: "Framer Motion",
        color: "pink",
      },
    ],
    image:
      "https://res.cloudinary.com/doe77lyoi/image/upload/v1725259884/iyenbkns11sctjxugpey.png",
    source_code_link: "https://github.com/Nimeshregmi",
  },

  {
    name: "TravelWings webiste",
    urls: "https://travelwings.com.np/",
    category: "web",
    description:
      "TravelWings official website that showcase their services and offers.",
    tags: [
      {
        name: "Tailwind",
        color: "blue",
      },
      {
        name: "Next.js",
        color: "green",
      },
      {
        name: "Framer Motion",
        color: "pink",
      },
    ],
    image: "/projects/travelwings.png",
    source_code_link: "https://github.com/Nimeshregmi",
  },
  {
    name: "Chat Application",
    description:
      "A chat application with signup Login and fully responsive design.",
    category: "web",
    tags: [
      {
        name: "nextjs",
        color: "blue",
      },
      {
        name: "Django",
        color: "green",
      },
      {
        name: "djangorestframework",
        color: "pink",
      },
      {
        name: "redux",
        color: "green",
      },
      {
        name: "tailwind",
        color: "blue",
      },
    ],
    image:
      "https://res.cloudinary.com/doe77lyoi/image/upload/v1725259884/bakpnh2szxx5s562jvpk.png",
    source_code_link: "https://github.com/Nimeshregmi/chat_App",
  },
  {
    name: "Expense Tracker",
    description:
      "Expense tracker application on Laravel with authentication and fully responsive design.",
    category: "web",
    tags: [
      {
        name: " Laravel",
        color: "blue",
      },
      {
        name: " TailwindCSS",
        color: "green",
      },
      {
        name: "AlpineJS",
        color: "pink",
      },
      {
        name: "Jquery",
        color: "green",
      },
      {
        name: "MySQL/Sqlite",
        color: "blue",
      },
      {
        name: " Laravel's breeze",
        color: "pink",
      },
    ],
    image: "/expense-tracker.png",
    source_code_link: "https://github.com/Nimeshregmi/expense-tracker",
  },
  {
    name: "Landing page",
    description:
      "Created a landing page with pure html, css and js which is fully responsive.",
    category: "web",
    tags: [
      {
        name: " Html",
        color: "blue",
      },
      {
        name: " css",
        color: "green",
      },
      {
        name: "js",
        color: "pink",
      },
    ],
    image: "/projects/practice.png",
    source_code_link: "https://github.com/Nimeshregmi/lex-nepal",
  },
];